import React from 'react'
import PropTypes from 'prop-types'

export default class OptionalActions extends React.Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    let { coursenum } = this.context.store.getState()
    let updateAssessmentsLink = `/links/client_canvas.update_assessments/${coursenum}/v2`
    let uploadGradesLink = `/links/client_canvas.upload_grades/${coursenum}/v2`
    let testConnectionLink = `/links/client_canvas.test_canvas_connection_v2/${coursenum}`

    return (
      <div className="card-myed">
        <div className="canvas-flex-wrapper">
          <div className="wrapper">
            <h3>Optional Actions</h3>
            <p>
              The following actions can be performed periodically if you feel
              that things are not syncing correctly.
            </p>
          </div>
          <div className="canvas-statusmarker-container">
            <img src="/static/instructor/media/canvas-logo-lms.png" />
          </div>
        </div>
        <div className="canvas-flex-wrapper space-around">
          <div className="action-panel">
            <div className="icon-wrapper">
              <div className="fad fa-file-check big-icon" />
            </div>
            <a
              href={updateAssessmentsLink}
              className="btn btn-primary btn-myed btn-primary-myed mt-3"
            >
              Update Assessments
            </a>
            <p>
              If you get any errors while turning on the switches, repeat step 2
              and the press this button to re-sync your assessments.
            </p>
          </div>
          <div className="action-panel">
            <div className="icon-wrapper">
              <div className="fad fa-cloud-upload big-icon" />
            </div>
            <a
              href={uploadGradesLink}
              className="btn btn-primary btn-myed btn-primary-myed mt-3"
            >
              Upload Grades
            </a>
            <p>
              Use this button if grades are missing or not synced for students.
            </p>
          </div>
          <div className="action-panel">
            <div className="icon-wrapper">
              <div className="fad fa-link big-icon needs-attention" />
            </div>
            <a
              href={testConnectionLink}
              className="btn btn-warning btn-myed btn-warning-myed"
            >
              Test Canvas Connection
            </a>
            <p>
              Press this button to test your connection to the Canvas Learning
              Management System.
            </p>
          </div>
        </div>
      </div>
    )
  }
}
